import { Modal, ModalHeader, ModalBody, Table, Row, Col, Button } from "reactstrap"
import { formatReadableDate } from "utils/formatDate"
import { formatBDT } from "utils/formatPrice"
import { calculateTotalPrice } from "utils/accessoryUtils"
import { useState } from "react"
import { getAccessoriesStockPdfById } from "api/accessoriesStockApi"

const AccessoriesStockViewModal = ({ isOpen, toggle, data }) => {
  const [loading, setLoading] = useState(false)
  if (!data) return null

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} className="border-0">
        <div className="w-100 text-center">
          <h4 className="mb-0 fw-bold">ACCESSORIES PURCHASE MEMO</h4>
        </div>
      </ModalHeader>

      <ModalBody className="px-4">
        {/* ===== Memo Meta ===== */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="mb-2">
              <strong>Purchased From:</strong>
              <div>{data.purchase_from?.name || "-"}</div>
            </div>
            <div>
              <strong>Purchased By:</strong>
              <div>{data.purchase_by?.name || "-"}</div>
            </div>
          </Col>

          <Col md={6} className="text-md-end">
            <div className="mb-2">
              <strong>Memo No:</strong>
              <div>{data.memo_no || "-"}</div>
            </div>
            <div>
              <strong>Purchase Date:</strong>
              <div>{formatReadableDate(data.purchase_date)}</div>
            </div>
          </Col>
        </Row>

        {/* ===== Items Table ===== */}
        <Table bordered responsive className="align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: 50 }}>#</th>
              <th>Accessory Name</th>
              <th style={{ width: 100 }} className="text-end">
                Quantity
              </th>
              <th style={{ width: 140 }} className="text-end">
                Unit Price
              </th>
              <th style={{ width: 160 }} className="text-end">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {data.items?.map((item, index) => (
              <tr key={item.id || index}>
                <td>{index + 1}</td>
                <td>{item.accessory?.name || "-"}</td>
                <td className="text-end">
                  {item.quantity} {item.accessory?.unit?.name || "-"}
                  {Number(item.quantity) < 0 && (
                    <div className="small text-danger">
                      <i className="fas fa-undo"></i> Returned
                    </div>
                  )}
                </td>
                <td className="text-end">{formatBDT(item.unit_price)}</td>
                <td className="text-end">
                  {formatBDT(
                    Number(item.quantity) * Number(item.unit_price || 0)
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* ===== Summary ===== */}
        <Row className="justify-content-end mt-4">
          <Col md={4}>
            <Table borderless>
              <tbody>
                <tr className="border-top">
                  <td className="fw-bold fs-5">Grand Total</td>
                  <td className="text-end fw-bold fs-5">
                    {formatBDT(calculateTotalPrice(data.items))}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <div className="text-end">
          <Button
            color="primary"
            onClick={() => getAccessoriesStockPdfById(data?.id, setLoading)}
            disabled={loading}
          >
            {loading ? "Generating PDF..." : "Download PDF"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default AccessoriesStockViewModal
